import React, { FC } from 'react'

import s from './WixMobilePage.scss'

export const WixMobilePage: FC = ({ children }) => {
  return <div className={s.page}>{children}</div>
}
